import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex h-screen overflow-hidden" }
const _hoisted_2 = { class: "relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden" }
const _hoisted_3 = { class: "w-11/12 mx-auto sm:px-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-semibold leading-tight" }, "Settings", -1)
const _hoisted_5 = { class: "relative overflow-x-auto shadow-md sm:rounded-lg" }
const _hoisted_6 = { class: "w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", { class: "text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3"
    }, " Company "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3"
    }),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3"
    })
  ])
], -1)
const _hoisted_8 = { class: "px-6 py-4" }
const _hoisted_9 = { class: "md:flex md:items-center" }
const _hoisted_10 = { class: "md:w-1/3" }
const _hoisted_11 = {
  class: "block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4",
  for: "inline-full-name"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "md:w-2/3" }, [
  /*#__PURE__*/_createElementVNode("input", {
    class: "bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500",
    id: "inline-full-name",
    type: "text",
    value: "Jane Doe"
  })
], -1)
const _hoisted_13 = { class: "px-6 py-4" }
const _hoisted_14 = { class: "px-6 py-4" }
const _hoisted_15 = ["onClick"]

import { ref , onMounted } from 'vue'
import SidebarView from './partials/SidebarView.vue'
import HeaderView from './partials/HeaderView.vue'
import settingService from '@/services/settingService'


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsView',
  setup(__props) {

const settings = ref('')
const showsettingsEdit = ref({
    key: ref(''),
    value: ref(''),
    id:ref(null)
})
const showIdSettings = ref(null)
const showInputSetting = ref(false)


const getSetting = () => {
  settingService.getSettings()
  .then(( response: any ) => {
    settings.value = response.data
    console.log(settings.value)
  })
  .catch((error:any) => {
    console.log(error)
  });
}

const showsettingsEditId  = (item : any) => {
    showIdSettings.value =item
  settingService.showEditSettingById(showIdSettings.value)
    .then(( response: any ) => {
        console.log(response.data)
        showsettingsEdit.value.key = response.data.key
        showsettingsEdit.value.value = response.data.value
        showInputSetting.value = true

    })
    .catch((error:any) => {
      console.log(error)
    });
}


onMounted(() => {
    getSetting()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SidebarView),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(HeaderView),
      _createElementVNode("main", null, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("table", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(settings.value, (setting, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    class: "odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700"
                  }, [
                    _createElementVNode("td", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("label", _hoisted_11, _toDisplayString(setting.key), 1)
                        ]),
                        _hoisted_12
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(setting.value), 1),
                    _createElementVNode("td", _hoisted_14, [
                      _createElementVNode("a", {
                        href: "#",
                        onClick: ($event: any) => (showsettingsEditId(setting.id)),
                        class: "font-medium text-blue-600 dark:text-blue-500 hover:underline"
                      }, "Edit", 8, _hoisted_15)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})